import proxy from "api/proxy";
import { getStorage } from "store/local";

function getEmployeeId(rec) {
  if (!rec) return null;
  const emp = rec.employee;
  if (typeof emp === "number") return emp;
  if (Array.isArray(emp)) return emp[0] ?? null;
  if (emp && typeof emp === "object") return emp.id ?? null;
  return rec.employee_id ?? null;
}

async function resolveEmployeeIds(records) {
  const missing = (records || []).filter((r) => !getEmployeeId(r));
  if (!missing.length) return records;
  const names = [...new Set(missing.map((r) => r.name).filter(Boolean))];
  if (!names.length) return records;
  try {
    const { data, error } = await proxy.search(
      "company.employee",
      [["rec_name", "in", names]],
      ["id", "rec_name"],
    );
    if (error || !data) return records;
    const map = new Map(data.map((e) => [e.rec_name, e.id]));
    return records.map((r) =>
      getEmployeeId(r) ? r : { ...r, employee_id: map.get(r.name) ?? null },
    );
  } catch (error) {
    console.error("Error resolving employee ids:", error);
    return records;
  }
}

async function getSections() {
  const session = await getStorage("ctxSession");
  const dom = [["chiefs", "=", session?.user_employee]];
  const limit = 260;
  const { data } = await proxy.search("staff.section", dom, ["name"], limit);
  return data;
}

export { getSections, getEmployeeId, resolveEmployeeIds };
